import { getStorageItem, removeStorageItem, setStorageItem, STORAGE_KEYS } from '@/lib/pwa-storage'

/**
 * Carrier de la fuente de adquisición en el cliente (DD17), sobre
 * `lib/pwa-storage` (guard de SSR y try/catch): `localStorage` sobrevive al
 * round-trip same-origin del OAuth y al abandono del alta, así que la marca
 * sigue ahí cuando el padre vuelve.
 *
 * NO es el `source` de lib/pending-signup.ts: aquel guarda el MÉTODO de login
 * (apple/google/otp); éste, de dónde vino el padre. Lo lee
 * contexts/auth-account-sync.ts al emitir `auth_*_completed` de un alta nueva.
 */
export const ACQUISITION_SOURCES = ['public-chat'] as const
export type AcquisitionSource = (typeof ACQUISITION_SOURCES)[number]

function isAcquisitionSource(value: string | null): value is AcquisitionSource {
  return (ACQUISITION_SOURCES as readonly (string | null)[]).includes(value)
}

export function storeAcquisitionSource(source: AcquisitionSource): void {
  setStorageItem(STORAGE_KEYS.ACQUISITION_SOURCE, source)
}

/** La fuente guardada, o `null` si no hay o no es una conocida (fail-closed). */
export function readAcquisitionSource(): AcquisitionSource | null {
  const source = getStorageItem(STORAGE_KEYS.ACQUISITION_SOURCE)
  return isAcquisitionSource(source) ? source : null
}

export function clearAcquisitionSource(): void {
  removeStorageItem(STORAGE_KEYS.ACQUISITION_SOURCE)
}
